import React from "react";
import Modal, { ModalTransition } from "@atlaskit/modal-dialog";
import apiClient from "../../api/admin-api-client";
import { toast } from "react-toastify";
import useAsync from "../../hooks/use-async";
import { useTranslation } from "react-i18next";

export default function RemoveSpace({ space, onRemoved, onClose }) {
    const { t } = useTranslation();
    const { run, isPending } = useAsync();
    const remove = () => {
        run(apiClient(`spaces/${space?.slug}`, { method: "DELETE"}))
            .then(() => {
                toast.success(t("admin_remove_space_success"));
                onRemoved && onRemoved();
            })
            .catch(error => toast.error(t("admin_remove_space_error") +  error.message));
    };

    return (
        <>
            <ModalTransition>
                <Modal
                    isLoading={isPending}
                    actions={[
                        { text: t("admin_remove_space_remove"), onClick: remove, isLoading: isPending },
                        { text: t("admin_remove_space_cancel"), onClick: onClose, isDisabled: isPending },
                    ]}
                    onClose={close}
                    heading={t("admin_remove_space_confirm")}
                    appearance="danger"
                >
                    <p>
                        {t("admin_remove_space_confirm_p")}
                    </p>
                </Modal>
            </ModalTransition>
        </>
    );
}